import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { IconElement } from "@/icons/types";

export interface AccordionRowProps {
  icon?: IconElement;
  iconAlignment?: "center" | "top";
  children: ReactNode;
  "data-test"?: string;
}

export const AccordionRow: FC<AccordionRowProps> = ({
  icon,
  iconAlignment = "center",
  children,
  "data-test": dataTest,
}) => (
  <Stack
    direction="row"
    gap={1}
    alignItems={icon && iconAlignment === "center" ? "center" : "flex-start"}
    data-test={dataTest}
  >
    {icon ? (
      <DashboardIcon size="medium" vibe="text-brand-moderate" sx={{ flexShrink: 0 }}>
        {icon}
      </DashboardIcon>
    ) : (
      <Box
        sx={(theme) => ({
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          height: theme.typography.body2.lineHeight,
        })}
      >
        <Box
          sx={(theme) => ({
            width: theme.spacing(0.5),
            height: theme.spacing(0.5),
            borderRadius: "50%",
            backgroundColor: theme.palette.surface.brand.intense,
          })}
        />
      </Box>
    )}
    <DashboardTypography variant="body2" vibe="text-neutral-moderate" component="div" sx={{ flex: 1, minWidth: 0 }}>
      {children}
    </DashboardTypography>
  </Stack>
);
